import React, { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function resetWindowScroll(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Resets window scroll after route content has laid out, so the new page paints at the top.
 * Wraps the route outlet inside Layout (parent layout effect runs after child layout effects).
 */
export const ScrollResetOutlet: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const scrollRestorationSetRef = useRef(false);

  useLayoutEffect(() => {
    if (scrollRestorationSetRef.current) return;
    scrollRestorationSetRef.current = true;
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    resetWindowScroll();
  }, [pathname]);

  return <>{children}</>;
};
